import { List } from '@mui/material'
import { styled } from '@mui/system';
import React from 'react'
import { useGetTermsQuery } from '../../redux/slices/consent'
import { TermsItem } from '../TermsItem';
import { useSearchParams } from "react-router-dom";
import { validateUrl } from '../../utils/url';

const StyledHeader = styled('div')`
  background-color: #01033b;
  color: white;
  font-family: 'Montserrat';
  padding: 18px;
  font-weight: 500;
  font-size: 18px;
  margin: 10px 0;
`;

export const TermsList = () => {
  const [searchParams] = useSearchParams();
  const product = searchParams.get("product");
  const redirect = searchParams.get("redirect");

  const { 
    data: terms, 
    error, 
    isLoading 
  } = useGetTermsQuery(product);

  if (error) {
    return <div>Oh no, there was an error</div>
  }

  if (isLoading) {
    return <div>Loading</div>
  }

  if (!terms) {
    return <div>No terms :(</div>
  }

  let sortedTerms = terms
    .map(term => ({
      ...term,
      sortDate: new Date(Math.max(...term.termsItems.map(e => new Date(e.createdOn)))),
      isGranted: term.termsItems.every(e => e.consent && e.consent.status === "Granted")
    }));

  sortedTerms.sort((a,b) => a.sortDate < b.sortDate ? 1 : -1);

  if (redirect && sortedTerms.every(item => item.isGranted)) {
    const validatedUrl = validateUrl(redirect);
    
    if (validatedUrl)
      window.location.href = validatedUrl;
  }

  return (
    <div>
      {
        sortedTerms
          .map(({ id, name, termsItems }) => (
            <div key={id}>
              <StyledHeader>
                  {name}
              </StyledHeader>
              <List>
              {
                termsItems.map(({ id: termsItemId, revision, ...termsItem }, index) => (
                  <TermsItem 
                    key={`${termsItemId}-${revision}`} 
                    index={index} 
                    {...termsItem} 
                    termsId={id} 
                    termsItemId={termsItemId} 
                    revision={revision}
                  />
                ))
              }
              </List>
            </div>
        ))
      }
    </div>
  )
}